import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { currentAnnotationQueueSelector } from '../../../redux/modules/annotation/currentAnnotationQueueSelector';

export type ColumnWidths = Record<string, number>;

export const useColumnWidths = () => {
  const [columnWidths, setColumnWidths] = useState<ColumnWidths>({});
  const currentQueue = useSelector(currentAnnotationQueueSelector);

  const setColumnWidth = useCallback(
    (columnId: string, width: number) => {
      setColumnWidths(prev => ({
        ...prev,
        [columnId]: width,
      }));

      // Save to localStorage when width changes
      if (currentQueue?.id) {
        const storageKey = `footer-column-width-${currentQueue.id}-${columnId}`;
        localStorage.setItem(storageKey, String(width));
      }
    },
    [currentQueue?.id]
  );

  const getColumnWidth = useCallback(
    (columnId: string): number | undefined => {
      // First check state
      if (columnWidths[columnId]) {
        return columnWidths[columnId];
      }

      // Then check localStorage if queue is available
      if (currentQueue?.id) {
        const storageKey = `footer-column-width-${currentQueue.id}-${columnId}`;
        const savedWidth = localStorage.getItem(storageKey);
        if (savedWidth) {
          const width = parseInt(savedWidth, 10);
          if (!isNaN(width)) {
            return width;
          }
        }
      }

      return undefined;
    },
    [columnWidths, currentQueue?.id]
  );

  return {
    setColumnWidth,
    getColumnWidth,
  };
};
